import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_EXAM_FEE_LISTING_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ExamFeeListingRequest {
  registrationExamLevelUuid: string;
  year: number;
}

export interface ExamFeeListingResponse {
  data: ExamFeeModelResponse[];
  lastUpdatedBy?: string;
  lastUpdatedAt?: string;
}

export interface ExamFeeModelResponse {
  uuid: string;
  gstPercent: number;
  gstInclusive: boolean;

  registrationFee: number;
  lateRegistrationFee: number;

  // Field for AEIS Exam
  admissionLevelCode?: string;
  admissionLevelDescription?: string;

  // Field for SPERS Exam
  firstTimerRegistrationFee?: number;
  secondTimerRegistrationFee?: number;
  firstTimerLateFee?: number;
  secondTimerLateFee?: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: ExamFeeListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostExamFeeListing = ({ onSuccess, onError }: Input) => {
  const postExamFeeListing = async (payload: ExamFeeListingRequest) => {
    const res = await axiosClient.post<ExamFeeListingResponse>(POST_EXAM_FEE_LISTING_URL, payload);
    return res.data;
  };

  return useCustomMutation(
    postExamFeeListing,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
